import React from "react";
import "./Build.css"; // Create this CSS file for styling
import { Container } from "react-bootstrap";
import { motion } from "framer-motion";

const BuidSolutions = () => {
  return (
    <motion.div
    className="Productright"
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, ease: "easeOut" }}
    viewport={{ once: true, amount: 0.3 }}
  >
    <div className="build-top-section">
    <Container className="build-section">
    <div className="buid-solutions">
      <h1>Built for Tomorrow</h1>
        <div>
      <div className="liner"></div>
      <div className="solutions-grid">
        <div className="solution-card">
          <h2 className="number" >50%</h2>
          <p>Enterprises will use industry cloud platforms by 2028 to accelerate business initiatives</p>
        </div>
        
        <div className="solution-card">
        <h2 className="number" >70%</h2>
          <p>Workloads will run in a cloud environment by 2028</p>
        </div>
        
        <div className="solution-card">
        <h2 className="number" >90%</h2>
          <p>Organizations believe cloud is the crucial ingredient for AI adoption</p>
        </div>

      </div>
      </div>
    </div>
    </Container>
    </div>
    </motion.div>
  );
};

export default BuidSolutions;